<template>
  <div class="content" v-if="outReportDetail.length != 0 || detailId.projectId || detailId.costReportId">
    <el-card>
      <div class="project" v-if="detailId.projectId">
        <span>项目信息</span>
        <p>项目名字：{{projectDetail.projectName}}</p>
        <p>负责人：{{projectDetail.managerName}}</p>
        <p>项目编号：{{projectDetail.projectIden}}</p>
        <el-divider></el-divider>
      </div>
      <div class="costreport" v-if="detailId.costReportId">
        <span>招待信息</span>
        <p>报备项目：{{costReportDetail.projectName}}</p>
        <p>报备类型：{{array[parseInt(costReportDetail.costType) - 1]}}</p>
        <p>消费时间：{{costReportDetail.useTime}}</p>
        <p>预估金额：{{costReportDetail.costMoney}}</p>
        <p>申请事由：{{costReportDetail.reportSubject}}</p>
        <p>消费人：{{costReportDetail.userName}}</p>
        <el-divider></el-divider>
      </div>
      <div class="out">
        <span>外出信息</span>
        <div v-for="(item, index) in outReportDetail" :key="index">
          <p>外出时间：{{item.outBegainTime}} - {{item.outEndTime}}</p>
          <p>外出人：{{ item.users?.replace(/，$/, '') }}</p>
          <p>外出地点：{{item.outAddress}}<a style="color: red">（{{item.publicTransport === 1 ? '公共交通' : '自驾'}}）</a></p>
          <p>外出事由：{{item.outSubject}}</p>
          <el-divider content-position="right">外出</el-divider>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import {requestProjectDetail, requestCostReportDetail, requestGetOutRecord} from "../../../api";
export default {
  name : "Detail",
  props: {"detailId": {}, "reflash": Number},
  data() {
    return {
      flash: this.reflash,
      projectDetail: {},
      costReportDetail: {},
      outReportDetail: [],
      array:['餐饮', '烟', '酒', '礼品', '其他']
    }
  },
  created() {
    if(this.detailId.projectId) {
      this.getProjectDetail(this.detailId.projectId)
    }
    if(this.detailId.costReportId) {
      this.getCostDetail(this.detailId.costReportId)
    }
    this.getOutRecord(this.detailId.reimburseId, this.detailId.userId)
  },
  watch: {
    reflash: {
      handler (n, o) {
        this.reset()

        if(this.detailId.projectId) {
          this.getProjectDetail(this.detailId.projectId)
        }
        if(this.detailId.costReportId) {
          this.getCostDetail(this.detailId.costReportId)
        }
        this.getOutRecord(this.detailId.reimburseId, this.detailId.userId)
      },
      deep: true // 默认值是 false，代表是否深度监听
    }
  },
  methods: {
    getProjectDetail(projectId) {
      requestProjectDetail({
        projectId: projectId
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            this.projectDetail = res.object.detail
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    getCostDetail(costReportId) {
      if (costReportId) {
        requestCostReportDetail({
          costReportId: costReportId
        }).then(res => {
          if (res.code == 200) {
            if (res.object) {
              this.costReportDetail = res.object.detail
            }
          } else {
            this.$message.error(res.msg);
          }
        })
      }
    },
    getOutRecord(reimburseId, userId) {
      requestGetOutRecord({
        reimburseId: reimburseId,
        userId: userId
      }).then(res => {
        if (res.code == 200) {
          this.outReportDetail = res.object
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    reset() {
      this.outReportDetail = []
      this.ProjectDetail = {}
      this.costReportDetail = {}
    }
  }
}
</script>

<style>
.content {
  max-height: 90vh;
  overflow-y: auto;
}

</style>
